<template style='height：100%'>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="content">
            <div class="title" >
                {{list.title}}
            </div>
            <div class="date" v-html='updateTime(list.created)'>

            </div>
            <el-divider></el-divider>
            <div class="provide-pic" >
                    <img
                            :src="imgUrl+list.img"
                            alt=""
                            style="width: 100%; height: 100%"
                    />
                            </div>
            <div class="text" v-html='list.content'>
              
            </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerList from "./public/header";
export default {
  name: "information",
  components: { headerList },
  data() {
    return {
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
        list:this.$route.query,
         imgUrl:'http://hk-huanggang.oss-cn-hangzhou.aliyuncs.com/',
    };
  },
  created(){

  },
  methods: {
     updateTime(item){
                let newList= item.split("T");
            return newList[0]
            },
    onSubmit() {

    },
    register() {

    },
  },
};
</script>
<style scoped>
.box {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.el-container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 7.1875rem /* 115px -> 7.1875rem */ !important;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  z-index: 99;
}
.el-main {
    width: 87.375rem /* 1398px -> 87.375rem */;
    min-height: 121.5625rem /* 1945px -> 121.5625rem */;
    background: #FDFBF5;
    box-shadow: 0px 2px 28px 2px rgba(198, 186, 173, 0.35);
    /*opacity: 0.6;*/
    margin: 0 auto;
    position: relative;
    top: 0;
    left: 0;
}
.content {
    width: 78rem /* 1248px -> 78rem */;
    height: 96rem /* 1536px -> 96rem */;
    margin:9.375rem /* 150px -> 9.375rem */ auto;
    border: 2px solid #C1B8AF;

}
.title{
    height: 6.25rem /* 100px -> 6.25rem */;
    font-size: 2rem /* 32px -> 2rem */;
    text-align: center;
    line-height: 6.25rem /* 100px -> 6.25rem */;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
    .date{
        height:.875rem /* 14px -> .875rem */;
        font-size: 1rem /* 16px -> 1rem */;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #000000;
        text-align: left;
        margin-left:3.125rem /* 50px -> 3.125rem */;
    }
    .text{
        width:65rem /* 1040px -> 65rem */;
        margin: 1.875rem /* 30px -> 1.875rem */ auto;
        height: 40.3125rem /* 645px -> 40.3125rem */;
        font-size: 1.125rem /* 18px -> 1.125rem */;
        text-indent:2em;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #000000;
        line-height: 1.875rem /* 30px -> 1.875rem */;
        letter-spacing:3px;

    }
    .pic{
        width: 80%;
        height: 28.3125rem /* 453px -> 28.3125rem */;
        margin:3.125rem /* 50px -> 3.125rem */ auto;
    }
    .provide-pic {
        width: 80% /* 408px -> 25.5rem */;
        height: 30% /* 223px -> 13.9375rem */;
        margin: .9375rem 10%/* 15px -> .9375rem */;
    }
</style>
